/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiTagsIdMutationRequest, PutApiTagsIdMutationResponse, PutApiTagsIdPathParams, PutApiTagsId400, PutApiTagsId401, PutApiTagsId403, PutApiTagsId404, PutApiTagsId500 } from "../../types/PutApiTagsId.ts";
import { putApiTagsIdMutationResponseSchema, putApiTagsIdMutationRequestSchema } from "../../zod/TagSchemas/putApiTagsIdSchema.ts";

function getPutApiTagsIdUrl({ id }: { id: PutApiTagsIdPathParams["Id"] }) {
  const res = { method: 'PUT', url: `/api/tags/${id}` as const }  
  return res
}

/**
 * @summary Обновление жанра по идентификатору
 * {@link /api/tags/:Id}
 */
export async function putApiTagsId({ id, data }: { id: PutApiTagsIdPathParams["Id"]; data?: PutApiTagsIdMutationRequest }, config: Partial<RequestConfig<PutApiTagsIdMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiTagsIdMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiTagsIdMutationResponse, ResponseErrorConfig<PutApiTagsId400 | PutApiTagsId401 | PutApiTagsId403 | PutApiTagsId404 | PutApiTagsId500>, PutApiTagsIdMutationRequest>({ method : "PUT", url : getPutApiTagsIdUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiTagsIdMutationResponseSchema.parse(res.data)
}